module.exports = __webpack_public_path__ + "img/justice.c65440d9.png";